function getTargetValue(currentValue, multiplier) {
  if (typeof currentValue === "number") {
    const averageValue = currentValue * multiplier;
    return Math.round(averageValue);
  }
  return 0;
}

export default getTargetValue;
